<template>
	<section id="latest" class="sg-section" style="background: #fff;">
		<v-container>
			<h2 class="sg-section-title">{{ content.title }}</h2>
			<div class="sg-gold-line"></div>
			<p class="sg-section-subtitle">{{ content.subtitle }}</p>

			<v-carousel class="sg-latest-carousel rounded-xl" :height="carouselHeight" hide-delimiter-background delimiter-icon="mdi-minus" show-arrows cycle>
				<v-carousel-item v-for="(group, i) in groupedItems" :key="i">
					<v-row class="fill-height pa-4" align="center" justify="center">
						<v-col v-for="item in group" :key="item.id" cols="12" sm="6" md="4">
							<v-card class="sg-product-card" elevation="0">
								<div class="sg-product-img" style="height: 160px;" @click="openQuickView(item)">
									<img :src="item.gallery ? item.gallery[0] : ''" :alt="item.name" style="width:100%;height:100%;object-fit:cover;" />
									<div class="sg-quick-view-overlay">
										<v-icon color="#1a1a1a">mdi-magnify-plus</v-icon>
										<span>مشاهده سریع</span>
									</div>
								</div>
								<v-card-text class="text-center pa-4">
									<v-chip x-small color="#C9A227" text-color="#1a1a1a" class="mb-2">جدید</v-chip>
									<h3 class="font-weight-bold mb-1" @click="openQuickView(item)">{{ item.name }}</h3>
									<div class="grey--text mb-2" style="font-size: 0.85rem;">
										{{ item.weight }} گرم — اجرت {{ item.wage }}٪
									</div>
									<div class="font-weight-bold" style="color: #C9A227;">
										{{ formatPrice(item.price) }} تومان
									</div>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-carousel-item>
			</v-carousel>

			<div v-if="editable" class="text-center mt-4">
				<v-btn small outlined color="primary" @click="edit()">ویرایش</v-btn>
			</div>
		</v-container>

		<v-dialog v-model="quickViewDialog" max-width="720px" scrollable>
			<v-card class="sg-quick-view-card" v-if="selectedProduct">
				<div class="sg-quick-view-layout">
					<div class="sg-quick-view-gallery">
						<v-carousel v-if="selectedProduct.gallery && selectedProduct.gallery.length" height="360" hide-delimiter-background>
							<v-carousel-item v-for="(img, i) in selectedProduct.gallery" :key="i">
								<img :src="img" :alt="selectedProduct.name + ' ' + (i + 1)" class="sg-gallery-img" />
							</v-carousel-item>
						</v-carousel>
						<div v-else class="sg-gallery-fallback">
							<v-icon size="96" color="#C9A227">{{ selectedProduct.icon }}</v-icon>
						</div>
						<div class="sg-gallery-badge">
							<v-icon small>mdi-camera-outline</v-icon>
							<span>{{ selectedProduct.gallery ? selectedProduct.gallery.length : 0 }} عکس</span>
						</div>
					</div>

					<div class="sg-quick-view-info pa-6">
						<div class="d-flex align-center justify-space-between mb-2">
							<v-chip small color="#C9A227" dark>
								<v-icon x-small left>mdi-tag-outline</v-icon>
								جدید
							</v-chip>
							<v-btn icon small @click="quickViewDialog = false">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</div>

						<h2 class="font-weight-bold mb-3" style="font-size: 1.4rem;">{{ selectedProduct.name }}</h2>

						<div class="d-flex flex-wrap justify-space-between mb-4" style="gap: 8px;">
							<span class="sg-price-tag">
								<v-icon x-small color="#C9A227">mdi-scale-balance</v-icon>
								وزن: {{ selectedProduct.weight }} گرم
							</span>
							<span class="sg-price-tag">
								<v-icon x-small color="#C9A227">mdi-hammer-wrench</v-icon>
								اجرت: {{ selectedProduct.wage }}٪
							</span>
							<span class="sg-price-tag">
								<v-icon x-small color="#C9A227">mdi-gold</v-icon>
								طلای ۱۸ عیار
							</span>
						</div>

						<v-divider class="mb-4"></v-divider>

						<div v-if="selectedProduct.description" class="mb-5">
							<h4 class="font-weight-bold mb-2" style="color: #C9A227; font-size: 0.95rem;">
								<v-icon x-small class="ml-1">mdi-text-box-outline</v-icon>
								توضیحات محصول
							</h4>
							<p class="grey--text text--darken-1 text-body-2" style="line-height: 2;">{{ selectedProduct.description }}</p>
						</div>

						<div class="d-flex align-end justify-space-between flex-wrap" style="gap: 12px;">
							<div>
								<div class="grey--text text--darken-1 subtitle-2 mb-1">قیمت روز</div>
								<div class="font-weight-bold" style="color: #C9A227; font-size: 1.6rem;">
									{{ formatPrice(selectedProduct.price) }}
									<small class="grey--text" style="font-size: 0.8rem;">تومان</small>
								</div>
							</div>
							<v-btn class="sg-btn-gold" large @click="quickOrder(selectedProduct)">
								<v-icon left>mdi-cart-plus</v-icon>
								ثبت سفارش
							</v-btn>
						</div>
					</div>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog v-model="settingsDialog" persistent max-width="600px">
			<v-card>
				<v-card-title>ویرایش جدیدترین زیورآلات</v-card-title>
				<v-card-text>
					<v-text-field v-model="settings.title" label="عنوان" outlined dense />
					<v-text-field v-model="settings.subtitle" label="زیرعنوان" outlined dense />
					<v-card v-for="(item, idx) in settings.items" :key="idx" outlined class="mb-3 pa-3">
						<v-row dense>
							<v-col cols="12"><v-text-field v-model="item.name" label="نام" dense outlined /></v-col>
							<v-col cols="4"><v-text-field v-model.number="item.weight" label="وزن" type="number" dense outlined /></v-col>
							<v-col cols="4"><v-text-field v-model.number="item.wage" label="اجرت %" type="number" dense outlined /></v-col>
							<v-col cols="4"><v-text-field v-model.number="item.price" label="قیمت" type="number" dense outlined /></v-col>
							<v-col cols="12" class="text-left">
								<v-btn x-small text color="red" @click="settings.items.splice(idx, 1)">حذف</v-btn>
							</v-col>
						</v-row>
					</v-card>
					<v-btn small color="primary" @click="addItem">افزودن آیتم</v-btn>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="settingsDialog = false">بستن</v-btn>
					<v-btn color="primary" :loading="submitEditLoading" @click="submitEdit">ذخیره</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import { cloneDeep } from 'lodash'
import { get } from 'vuex-pathify'
import api from '@/util/app-api'
import { emptyId } from '@/util/emptyId'
import toast from '@/util/toast'

export default {
	name: 'LatestSection',
	props: {
		data: { type: Object },
		contentKey: { type: String },
		editable: { type: Boolean },
		goldPrice: { type: Number },
	},
	data: () => ({
		localData: null,
		settings: {},
		settingsDialog: false,
		submitEditLoading: false,
		quickViewDialog: false,
		selectedProduct: null,
	}),
	computed: {
		...get('siteConfig', ['customerCode']),
		content() {
			return this.localData?.content || this.defaultContent()
		},
		ccode() {
			return this.customerCode || this.$route.params.customerCode || 0
		},
		carouselHeight() {
			return this.$vuetify.breakpoint.smAndDown ? 380 : 320
		},
		groupedItems() {
			let items = this.content.items || []
			items = items.map(x => {
				let prd = { ...x }
				prd.price = prd.weight * this.goldPrice
				return prd
			})
			const groups = []
			for (let i = 0; i < items.length; i += 3) {
				groups.push(items.slice(i, i + 3))
			}
			return groups.length ? groups : [[]]
		},
	},
	mounted() {
		if (this.data) {
			this.localData = {
				id: this.data.id,
				key: this.data.key,
				isJson: this.data.isJson,
				content: JSON.parse(this.data.content),
			}
		} else {
			this.localData = {
				id: emptyId,
				key: this.contentKey,
				isJson: true,
				content: this.defaultContent(),
			}
		}
	},
	methods: {
		defaultContent() {
			return {
				title: 'جدیدترین زیورآلات',
				subtitle: 'تازه‌ترین طراحی‌های طلا و جواهر',
				items: [
					{ id: 1, name: 'گردنبند طلا طرح ماه', weight: 0.76, wage: 17, price: 32800000, icon: 'mdi-necklace', description: 'گردنبند طلای ۱۸ عیار با طرح ماه، طراحی خاص و زیبا مناسب استفاده روزمره و مجلسی.', gallery: ['https://safegolds.com/gallery/IMG_20260913_105525_942.jpg'] },
					{ id: 2, name: 'انگشتر طلا کلاسیک', weight: 2.0, wage: 18, price: 18900000, icon: 'mdi-ring', description: 'انگشتر کلاسیک طلای ۱۸ عیار، طراحی ساده و شیک مناسب استفاده روزانه.', gallery: ['https://safegolds.com/gallery/IMG_20260915_172418_988.jpg'] },
					{ id: 3, name: 'دستبند طلا کار شده', weight: 0.8, wage: 20, price: 48500000, icon: 'mdi-watch-variant', description: 'دستبند طلای کار شده با ظرافت بالا، طراحی منحصربه‌فرد و دست‌ساز.', gallery: ['https://safegolds.com/gallery/IMG_20260820_120945_288.jpg'] },
					{ id: 4, name: 'گوشواره طلا الماس', weight: 4.01, wage: 22, price: 17200000, icon: 'mdi-ear-hearing', description: 'گوشواره طلای الماس‌نشان، طراحی خیره‌کننده مناسب مهمانی و مجالس.', gallery: ['https://safegolds.com/gallery/IMG_20260819_121225_674.jpg'] },
					{ id: 5, name: 'ست طلا عروس', weight: 12.3, wage: 19, price: 142000000, icon: 'mdi-diamond-stone', description: 'ست کامل طلای عروس شامل گردنبند، گوشواره و دستبند با جعبه مخملی.', gallery: ['https://safegolds.com/gallery/IMG_20260915_110222_923.jpg'] },
					{ id: 6, name: 'پابند طلا ظریف', weight: 1.2, wage: 15, price: 23500000, icon: 'mdi-foot-print', description: 'پابند ظریف طلای ۱۸ عیار مناسب فصول گرم، طراحی سبک و راحت.', gallery: ['https://safegolds.com/gallery/Annotation-2026-09-16-125426.jpg'] },
				],
			}
		},
		formatPrice(val) {
			return Number(val).toLocaleString('fa-IR')
		},
		openQuickView(item) {
			this.selectedProduct = item
			this.quickViewDialog = true
		},
		quickOrder(product) {
			this.quickViewDialog = false
			this.$emit('order', product)
		},
		edit() {
			this.settings = cloneDeep(this.content)
			this.settingsDialog = true
		},
		addItem() {
			this.settings.items.push({ id: Date.now(), name: '', weight: 0, wage: 0, price: 0, icon: 'mdi-diamond-stone' })
		},
		submitEdit() {
			this.submitEditLoading = true
			const data = cloneDeep(this.localData)
			data.content = JSON.stringify(this.settings)
			api.post('admin/SiteContent/CreateUpdate', data)
				.then(() => {
					this.localData.content = cloneDeep(this.settings)
					toast.success('اطلاعات با موفقیت ذخیره شد.')
					this.settingsDialog = false
				})
				.catch(err => toast.error(err.message))
				.finally(() => { this.submitEditLoading = false })
		},
	},
}
</script>

<style scoped>
.sg-quick-view-overlay {
	position: absolute;
	inset: 0;
	background: rgba(201, 162, 39, 0.55);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	color: #1a1a1a;
	font-weight: 700;
	font-size: 0.9rem;
	opacity: 0;
	transition: opacity 0.35s ease;
	cursor: pointer;
}

.sg-product-card:hover .sg-quick-view-overlay {
	opacity: 1;
}

.sg-quick-view-card {
	border-radius: 16px !important;
	overflow: hidden;
}

.sg-quick-view-layout {
	display: flex;
	flex-wrap: wrap;
}

.sg-quick-view-gallery {
	position: relative;
	flex: 1 1 340px;
	max-width: 100%;
	background: linear-gradient(145deg, #FFF9F0, #F5E6A3);
}

.sg-quick-view-info {
	flex: 1 1 320px;
	min-width: 280px;
	display: flex;
	flex-direction: column;
}

.sg-gallery-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.sg-gallery-fallback {
	height: 360px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.sg-gallery-badge {
	position: absolute;
	top: 16px;
	right: 16px;
	background: rgba(26, 26, 26, 0.75);
	color: #fff;
	border-radius: 999px;
	padding: 4px 14px;
	font-size: 0.8rem;
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

@media (max-width: 600px) {
	.sg-quick-view-gallery .v-carousel {
		height: 260px !important;
	}

	.sg-gallery-fallback {
		height: 260px;
	}
}
</style>
